module.exports = __webpack_public_path__ + "img/mentalIntro1.c04d4410.png";